import * as types from 'modules/dealers/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/** @typedef {boolean} State */

/** @type State */
const initialState = false;

/**
 * @returns {State}
 */
const open = () => true;

/**
 * @returns State
 */
const close = () => false;

export default createReducer(initialState, {
  [types.OPEN_SELECT_DEALER_MODAL]: open,
  [types.CLOSE_SELECT_DEALER_MODAL]: close,
});
